module.exports = __webpack_public_path__ + "img/item24.6d670818.png";